import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/Loader/LoadingSpinner";
import Modal from "../../components/ImageModal/ImageModal";
import { useNavigate } from "react-router-dom";
import API_UTIL from "../../services/AuthIntereptor";
import Footer from "../../components/Footer/Footer";
import "../../components/Footer/Footer.css";
import AppBar from "../../components/AppBar/AppBar";
import MiniHeroComponent from "../../components/MiniHeroComponent/MiniHeroComponent";
import defaultBanner from '../../media/images/defaultBanner.jpg';
import { Button, Icons } from "../../components/ui";


function FavoriteImages() {
  const [isLoading, setIsLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [clickedImg, setClickedImg] = useState(null);
  const [clickedImgIndex, setClickedImgIndex] = useState(null);
  const [clickedImgFavourite, setClickedImgFavourite] = useState(null);
  const [clickedUrl, setClickedUrl] = useState(null);
  const [continuationToken, setContinuationToken] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [clientObj, setClientObj] = useState(null);
  const [bannerImg, setBannerImg] = useState(null);
  const { folderName, eventId } = useParams();
  const navigate = useNavigate();
  const loader = useRef(null);
  const [bannerImage, setBannerImage] = useState('');
  const [eventOwners, setEventOwners] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showDownload, setShowDownload] = useState(true);

  const [breakpointColumnsObj, setBreakpointColumnsObj] = useState({
    default: 6,
    1200: 5,
    992: 4,
    768: 3,
    576: 2,
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpointColumnsObj({
        default: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const disablePinchZoom = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", disablePinchZoom, {
      passive: false,
    });
    return () => {
      document.removeEventListener("touchmove", disablePinchZoom);
    };
  }, []);


  useEffect(() => {
    // Initial image fetch
    if(folderName === 'favourites'){
      setShowDownload(false);
      fetchEventFavouriteImages();
    }
  },[eventId]);

  const fetchEventOwners = async () => {
    try {
      const response = await API_UTIL.get(`/getEventOwners/${eventId}`);
      if (response.status ===200){
        return response.data;
      } else{
        throw new Error('Failed to fetch');
      }
    } catch (err) {
      console.log(err.message);
      throw new Error('Failed to fetch');
    }
  };
  const fetchEventFavouriteImages = async()=>{
    setIsLoading(true);
    try {
      const eventOwners = await fetchEventOwners();
      for(const owner of eventOwners.owners){
      const response = await API_UTIL.get(`/getOwnerFavImages/${eventOwners.folder_name}/${owner}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
        // If you need to send body data or authentication, include it here
      });
      if(response.status === 200){

        const formattedImages = response.data.map((obj) => {
  // Replace 'Deliverables/' with 'Deliverables/thumbnails/' to get the thumbnail URL
  const thumbnailUrl = obj.s3_url.replace('/Deliverables/', '/Deliverables/thumbnails/');

  return {
    original: obj.s3_url,
    thumbnail: thumbnailUrl,
  };
});

        setImages((prevImages) => {
          // Create a set of existing image URLs to quickly check for duplicates
          const existingImageUrls = new Set(prevImages.map((image) => image.original));

          // Filter out any images that already exist in the current state
          const newImages = formattedImages.filter(
            (image) => !existingImageUrls.has(image.original)
          );

          // Return a new array with the existing images and the filtered new images
          return [...prevImages, ...newImages];
        });
      }
    }
    } catch (error) {
      console.log(error.message);
    }
  };


  useEffect(() => {
    const fetchClientDetails = async (eventId) => {

      try {
        const response = await API_UTIL.get(`/getClientDetailsByEventId/${eventId}`);
        if (response.status === 200) {
          setClientObj(response.data);
        } else {
          throw new Error("Failed to fetch client Details");
        }
      } catch (error) {
        console.error("Error fetching user thumbnails:", error);
        setIsLoading(false);
      }
    };
    if(eventId){
      fetchClientDetails(eventId);
    }
  }, [eventId]);

  const encodeURIWithPlus = (uri) => {
    return uri.replace(/ /g, '+');
  };

  useEffect(()=>{
  const fetchBannerImage = async () => {
      setIsLoading(true);
    if (clientObj.org_name && clientObj.user_name) {
      try {
        const response = await API_UTIL.get(`/getBannerImage/${clientObj.user_name}`);

        if (response.data && response.data.imageUrl) {
          const formattedUrl = encodeURIWithPlus(response.data.imageUrl);

          setBannerImage(`${formattedUrl}?t=${Date.now()}`);
        } else {
          console.log('[catch1]Falling back to default banner');
          setBannerImage(defaultBanner);
        }
      } catch (error) {
        console.error('Error fetching banner image:', error);
        console.log(`[catch2]Falling back to default banner`);
        setBannerImage(defaultBanner);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log(`[catch3]Falling back to default banner`);
      setBannerImage(defaultBanner);
      setIsLoading(false);
    }
  }
  if(clientObj){
    fetchBannerImage();
  }

},[clientObj]);

  const handleClick = (item, index) => {
    setClickedImg(item.thumbnail);
    setClickedImgIndex(index);
    setClickedImgFavourite(item.isFavourites);
    setClickedUrl(item.original);
    window.history.pushState({ id: 1 }, null, "?image=" + `${item.original.split('/').pop()}`);
  };

  const handleBackButton = () => {
    setClickedImg(null);
  };

  useEffect(() => {
    window.addEventListener("popstate", handleBackButton);
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !isLoading) {
        }
      },
      {
        root: null, // Relative to the viewport
        rootMargin: "0px",
        threshold: 0.5, // Trigger when 50% of the loader is visible
      }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) {
        observer.unobserve(loader.current);
      }
    };
  }, [hasMore, isLoading]); // Updated dependencies


  return (
    <div className="bg-white text-slate-900 min-h-screen flex flex-col">
      {isLoading && images.length === 0 ? (
        <div className="grid place-items-center min-h-screen">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <AppBar />

          {/* Hero band */}
          <div className="relative h-56 sm:h-72 overflow-hidden border-b border-gray-200">
            {clientObj && (
              <MiniHeroComponent
                userName={clientObj.user_name}
                orgName={clientObj.org_name}
                socialMediaLinks={clientObj.social_media}
                backdropImage={bannerImage}
              />
            )}
          </div>

          <div className="fade-in max-w-[1400px] mx-auto w-full px-4 sm:px-6 py-8 flex-1">
            {images.length > 0 && showDownload && (
              <div className="mb-5 flex justify-center sm:justify-start">
                <Button
                  variant="secondary"
                  icon={Icons.Download}
                  title="Download QR Code"
                  disabled={isDownloading}
                >
                  {isDownloading ? "Downloading..." : "Download All"}
                </Button>
              </div>
            )}
            {images.length > 0 ? (
              <div>
                <div className="masonry columns-2 sm:columns-3 lg:columns-3 xl:columns-4">
                  {images.map((item, index) => (
                    <div
                      key={index}
                      className="relative rounded-xl overflow-hidden bg-gray-100 border border-gray-200 group mb-4 cursor-pointer"
                    >
                      <img
                        src={item.thumbnail}
                        alt={`img ${index}`}
                        className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105"
                        onClick={() => handleClick(item, index)}
                      />
                    </div>
                  ))}
                </div>
                <div ref={loader} style={{ height: '20px', marginTop: '20px' }} />
                {clickedImg && (
                  <div className="fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-black z-[1000] flex items-center justify-center">
                    <Modal
                      clickedImg={clickedImg}
                      clickedImgIndex={clickedImgIndex}
                      clickedImgFavourite={clickedImgFavourite}
                      setClickedImg={setClickedImg}
                      clickedUrl={clickedUrl}
                      handleBackButton={handleBackButton}
                      images={images}
                      favourite={false}
                    />
                  </div>
                )}
              </div>
            ) : (
              <p className="text-center text-slate-500 text-lg py-24">No favorites to display</p>
            )}
          </div>
          <Footer />
        </>
      )}
    </div>
  );
}

export default FavoriteImages;
